import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IAddress } from '../../Models/common.model';
import { StateDropdownComponent } from '../../States/State-Dropdown/state.dropdown.component';

@Component({
    selector: 'address-view-edit',
    templateUrl: './address.view.edit.component.html',
    imports: [
        CommonModule,
        FormsModule,
        StateDropdownComponent
    ]
})
export class AddressViewEditComponent {
    @Input() address: IAddress;
    @Input() isEditMode: boolean;
    @Input() shouldIncludeDetails: boolean;
    @Input() shouldRestrictExtended: boolean;
    @Input() isSmall: boolean;
    @Input() readOnlyState: boolean;
    @Input() removeBottomMargin: boolean;
}
